/* eslint no-console: 0 */
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { withModalTitle } from '../../../hooks/modal/withModalTitle.tsx';
import { ApiAccessRoute } from './ApiAccessRoute.tsx';
import { ChangePassword } from './ChangePassword.tsx';
import { EditName } from './EditName.tsx';
import { EditPhone } from './EditPhone.tsx';
import NotificationsRoute from './NotificationsRoute.jsx';
import { SettingsHome } from './SettingsHome.tsx';

interface SettingsRouteProps { };

const NotificationsRouteWithTitle = withModalTitle(NotificationsRoute, 'Notifications');

export const SettingsRoute: React.FC<SettingsRouteProps> = () => {

  let { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={path}
        component={SettingsHome}
      />
      <Route exact path={`${path}/change-password`} component={ChangePassword} />
      <Route
        exact
        path={`${path}/notifications`}
        component={NotificationsRouteWithTitle}
      />
      <Route exact path={`${path}/edit-name`} component={EditName} />
      <Route path={`${path}/edit-phone`} component={EditPhone} />
      <Route exact path={`${path}/api`} component={ApiAccessRoute} />
    </Switch>
  );
}
